import Vue from "vue";
import VueRouter from "vue-router";
import Introduction from "../views/01_Introduction.vue";
import JozsefNemeth from "../views/02_JozsefNemeth.vue";
import ZsuzsaHorvath from "../views/03_ZsuzsaHorvath.vue";
import OcnaSibiului from "../views/04_OcnaSibiului.vue";
import HiddenGalleries from "../views/05_HiddenGalleries.vue";
import Epilogue from "../views/06_Epilogue.vue";
import Imprint from "../views/07_Imprint.vue";
import ErrorPage from "../views/ErrorPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "01_Introduction",
    component: Introduction
  },
  {
    path: "/the-story-of-jozsef-nemeth",
    name: "02_JozsefNemeth",
    component: JozsefNemeth
  },
  {
    path: "/faith-trust-secrecy",
    name: "03_ZsuzsaHorvath",
    component: ZsuzsaHorvath
  },
  {
    path: "/the-secret-police-photo-album",
    name: "04_OcnaSibiului",
    component: OcnaSibiului
  },
  {
    path: "/hidden-galleries",
    name: "05_HiddenGalleries",
    component: HiddenGalleries
  },
  {
    path: "/epilogue-on-trust",
    name: "06_Epilogue",
    component: Epilogue
  },
  {
    path: "/imprint",
    name: "07_Imprint",
    component: Imprint
  },
  {
    path: "/*",
    name: "ErrorPage",
    component: ErrorPage
  }
];

const router = new VueRouter({
  mode: "history",
  scrollBehavior: (to, from) => {
    if (to.path != from.path) {
      return { y: 0 };
    }
  },
  base: process.env.BASE_URL,
  linkExactActiveClass: "active",
  routes
});

export default router;
